module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-offset-2 col-md-8",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('cart-widget')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17c3f0ed"}!./src/pages/Buypoint/Order/template.html
// module id = 188
// module chunks = 1